import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SeoHead from "@/components/SeoHead";


/**
 * APK 下载页面。
 * 安卓端强制升级/自动升级的兜底页面 + 网站直接下载入口。
 */
export default function DownloadPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white flex flex-col">
      <SeoHead
        path="download"
        title={t("download.seo_title", "Download BamaBang - Android APK")}
        description={t(
          "download.seo_desc",
          "Download the latest version of BamaBang app for Android. Direct APK download, no Google Play required."
        )}
      />

      {/* Header */}
      <header className="p-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img src="/favicon.png" alt="Logo" className="w-12 h-12 mr-2" />
          <span className="font-bold text-gray-900 text-xl hidden sm:block">
            BamaBang
          </span>
        </Link>
        <Link
          to="/"
          className="text-sm text-gray-600 hover:text-gray-900 transition"
        >
          ← {t("common.back", "Back")}
        </Link>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center p-4">
        <div className="max-w-lg w-full text-center space-y-8">
          <div className="text-6xl">📥</div>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            {t("download.title", "Download MamaMatch")}
          </h1>

          <p className="text-lg text-gray-600">
            {t(
              "download.description",
              "Download the latest version of MamaMatch for Android. Install directly — no app store required."
            )}
          </p>

          {/* Download Button Disabled */}
          <button
            disabled
            className="inline-flex items-center justify-center px-10 py-5 bg-gray-400 text-white rounded-2xl shadow-none cursor-not-allowed text-lg font-bold w-full md:w-auto"
          >
            <span className="text-2xl mr-3">🤖</span>
            {t("download.android_coming_soon", "Coming soon")}
          </button>

          {/* Install Instructions */}
          <div className="bg-white rounded-2xl shadow-sm p-6 text-left space-y-4">
            <h2 className="text-lg font-bold text-gray-900">
              {t("download.install_title", "Installation Guide")}
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-600 text-sm">
              <li>
                {t(
                  "download.step1",
                  "Tap the download button above to download the APK file."
                )}
              </li>
              <li>
                {t(
                  "download.step2",
                  "Open the downloaded file. If prompted, go to Settings and enable 'Install from unknown sources'."
                )}
              </li>
              <li>
                {t(
                  "download.step3",
                  "Follow the on-screen instructions to complete the installation."
                )}
              </li>
              <li>
                {t(
                  "download.step4",
                  "Open the app and login with your existing account."
                )}
              </li>
            </ol>
          </div>

          {/* Security Notice */}
          <div className="bg-green-50 rounded-xl p-4 text-sm text-green-800">
            🛡️{" "}
            {t(
              "download.security_notice",
              "This APK is provided directly by BamaBang. It is safe and verified. We recommend always downloading from this official page."
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="p-6 text-center text-xs text-gray-400">
        <p>© 2026 bamabang.net. All rights reserved.</p>
      </footer>
    </div>
  );
}
